import React, { ReactElement } from 'react';
import { NextPageWithLayout } from 'next';
import StaticPageComponent from '@fuww/library/src/StaticPage';
import { useIntl } from 'react-intl';
import markdown from '../data/staticPages/companydirectory.md';
import LinkAndAnchor from '../components/LinkAndAnchor';
import Layout from '../components/Layout';
import Head from '../components/Head';
import HomeLink from '../components/HomeLink';
import messages from '../lib/messages.json';
import Markdown from '../components/Markdown';

const CompanyDirectoryPage: NextPageWithLayout = () => {
  const intl = useIntl();

  const breadcrumbs = [
    <HomeLink />,
    <LinkAndAnchor
      route="companydirectory"
      passHref
    >
      {intl.formatMessage(messages['info.features.companyDirectory'])}
    </LinkAndAnchor>,
  ];
  return (
    <>
      <Head
        title={intl.formatMessage(messages['info.features.companyDirectory'])}
        description={
          intl.formatMessage(messages['info.features.companyDirectory'])
        }
      />
      <StaticPageComponent
        content={<Markdown markdown={markdown} />}
        title={intl.formatMessage(messages['info.features.companyDirectory'])}
        breadcrumbs={breadcrumbs}
      />
    </>

  );
};

CompanyDirectoryPage.getLayout = (page: ReactElement) => (
  <Layout>
    {page}
  </Layout>
);

export default CompanyDirectoryPage;
